/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Datastore API
 * API reference for Datastore API.
 *
 * Authentication: Auth0
 *
 * OpenAPI spec version: 3.0.0
 */
import type {
  CreateFilesCommentRequestBody,
  CreateFilesCommentResponse,
  CreateFilesDownloadRequestBody,
  CreateFilesDownloadResponse,
  CreateFilesUploadRequestBody,
  CreateFilesUploadResponse,
  DeleteFilesCommentResponse,
  DeleteFilesRequestBody,
  DeleteFilesResponse,
  FilesCsvExportParams,
  GetFileGeoPointsParams,
  GetFileGeoPointsResponse,
  GetFileGroupsParams,
  GetFileGroupsResponse,
  GetFilePageNumberParams,
  GetFilePageNumberResponse,
  GetFileParams,
  GetFileResponse,
  GetFileThumbnailsParams,
  GetFileThumbnailsResponse,
  GetFilesCountsParams,
  GetFilesCountsResponse,
  GetFilesDownloadResponse,
  GetFilesParams,
  GetFilesResponse,
  SuccessExecutionTemperatureExtractorResponse,
  UpdateFileRequestBody,
  UpdateFileResponse,
  UpdateFilesCommentRequestBody,
  UpdateFilesCommentResponse,
  UpdateFilesRequestBody,
  UpdateFilesResponse
} from '../model';

import getFilesMutator from '../../../mutators/datastore-instance';
import putFilesMutator from '../../../mutators/datastore-instance';
import deleteFilesMutator from '../../../mutators/datastore-instance';
import getFileMutator from '../../../mutators/datastore-instance';
import putFileMutator from '../../../mutators/datastore-instance';
import getFilePageNumberMutator from '../../../mutators/datastore-instance';
import postFilesUploadMutator from '../../../mutators/datastore-instance';
import postFilesCommentMutator from '../../../mutators/datastore-instance';
import putFilesCommentMutator from '../../../mutators/datastore-instance';
import deleteFilesCommentMutator from '../../../mutators/datastore-instance';
import getFilesCountsMutator from '../../../mutators/datastore-instance';
import postFilesDownloadMutator from '../../../mutators/datastore-instance';
import getFilesDownloadMutator from '../../../mutators/datastore-instance';
import filesCsvExportMutator from '../../../mutators/datastore-instance';
import getFileGroupsMutator from '../../../mutators/datastore-instance';
import getFileThumbnailsMutator from '../../../mutators/datastore-instance';
import getFileGeoPointsMutator from '../../../mutators/datastore-instance';
import getFileTemperatureMutator from '../../../mutators/datastore-instance';



  /**
 * ファイル の一覧を取得できます。
 * @summary ファイル の一覧
 */
export const getFiles = (
    params?: GetFilesParams,
 ) => {
      return getFilesMutator<GetFilesResponse>(
      {url: `/files`, method: 'GET',
        params
    },
      );
    }
  /**
 * ファイル を一括更新できます。
 * @summary ファイル の一括更新
 */
export const putFiles = (
    updateFilesRequestBody?: UpdateFilesRequestBody,
 ) => {
      return putFilesMutator<UpdateFilesResponse>(
      {url: `/files`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateFilesRequestBody
    },
      );
    }
  /**
 * ファイル を一括削除できます。
 * @summary ファイル の一括削除
 */
export const deleteFiles = (
    deleteFilesRequestBody?: DeleteFilesRequestBody,
 ) => {
      return deleteFilesMutator<DeleteFilesResponse>(
      {url: `/files`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteFilesRequestBody
    },
      );
    }
  /**
 * ファイルの詳細取得する
 * @summary ファイル詳細取得
 */
export const getFile = (
    fileId: number,
    params?: GetFileParams,
 ) => {
      return getFileMutator<GetFileResponse>(
      {url: `/files/${fileId}`, method: 'GET',
        params
    },
      );
    }
  /**
 * ファイルを更新します。
 *
 * FCDS-5695: 単数/一括の永続化実装の一本化に伴い非推奨となりました。
 * 新規実装は PUT /files (put-files) を使用してください。
 * @deprecated
 * @summary ファイル更新
 */
export const putFile = (
    fileId: number,
    updateFileRequestBody?: UpdateFileRequestBody,
 ) => {
      return putFileMutator<UpdateFileResponse>(
      {url: `/files/${fileId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateFileRequestBody
    },
      );
    }
  /**
 * ファイルのページ番号を取得する
 * @summary ページ番号取得
 */
export const getFilePageNumber = (
    fileId: number,
    params?: GetFilePageNumberParams,
 ) => {
      return getFilePageNumberMutator<GetFilePageNumberResponse>(
      {url: `/files/${fileId}/page-number`, method: 'GET',
        params
    },
      );
    }
  /**
 * ファイルをアップロードする
 * ワークフローを起動する場合、そのワークフローを自動書き込みの対象にしている書込ルールをすべて書込先として実行へ紐づけます（0 件なら紐づけません）。
 * ワークフローの起動処理中に削除された書込ルールは紐づけず、アップロードはそのまま完了します。
 * @summary ファイルアップロード
 */
export const postFilesUpload = (
    createFilesUploadRequestBody?: CreateFilesUploadRequestBody,
 ) => {
      return postFilesUploadMutator<CreateFilesUploadResponse>(
      {url: `/files/upload`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createFilesUploadRequestBody
    },
      );
    }
  /**
 * ファイルにコメントを追加する
 * @summary ファイルにコメントを追加する
 */
export const postFilesComment = (
    fileId: number,
    createFilesCommentRequestBody?: CreateFilesCommentRequestBody,
 ) => {
      return postFilesCommentMutator<CreateFilesCommentResponse>(
      {url: `/files/${fileId}/comments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createFilesCommentRequestBody
    },
      );
    }
  /**
 * ファイルコメントを更新する
 * @summary ファイルコメントを更新する
 */
export const putFilesComment = (
    fileId: number,
    commentId: number,
    updateFilesCommentRequestBody?: UpdateFilesCommentRequestBody,
 ) => {
      return putFilesCommentMutator<UpdateFilesCommentResponse>(
      {url: `/files/${fileId}/comments/${commentId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateFilesCommentRequestBody
    },
      );
    }
  /**
 * ファイルコメントを削除する
 * @summary ファイルコメントを削除する
 */
export const deleteFilesComment = (
    fileId: number,
    commentId: number,
 ) => {
      return deleteFilesCommentMutator<DeleteFilesCommentResponse>(
      {url: `/files/${fileId}/comments/${commentId}`, method: 'DELETE'
    },
      );
    }
  /**
 * ファイル数を取得する
 * @summary ファイル数を取得する
 */
export const getFilesCounts = (
    params?: GetFilesCountsParams,
 ) => {
      return getFilesCountsMutator<GetFilesCountsResponse>(
      {url: `/files/counts`, method: 'GET',
        params
    },
      );
    }
  /**
 * fileのzipダウンロードタスク作成する
 * @summary fileのzipダウンロードタスク作成
 */
export const postFilesDownload = (
    createFilesDownloadRequestBody?: CreateFilesDownloadRequestBody,
 ) => {
      return postFilesDownloadMutator<CreateFilesDownloadResponse>(
      {url: `/files/downloads`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createFilesDownloadRequestBody
    },
      );
    }
  /**
 * fileのzipダウンロードタスクをチェックする
 * @summary fileのzipダウンロードタスクをチェックする
 */
export const getFilesDownload = (
    downloadId: number,
 ) => {
      return getFilesDownloadMutator<GetFilesDownloadResponse>(
      {url: `/files/downloads/${downloadId}`, method: 'GET'
    },
      );
    }
  /**
 * fileの一覧をcsvで出力する
 * @summary fileの一覧をcsvで出力する
 */
export const filesCsvExport = (
    params?: FilesCsvExportParams,
 ) => {
      return filesCsvExportMutator<Blob>(
      {url: `/files/export`, method: 'GET',
        params,
        responseType: 'blob'
    },
      );
    }
  /**
 * ファイルをグループ化した一覧を取得できます。ページネーションは cursor 方式のみサポートします。
 * @summary ファイルのグループ一覧
 */
export const getFileGroups = (
    params?: GetFileGroupsParams,
 ) => {
      return getFileGroupsMutator<GetFileGroupsResponse>(
      {url: `/files/groups`, method: 'GET',
        params
    },
      );
    }
  /**
 * ファイルのサムネイル情報を含む一覧を取得できます。
 * @summary ファイルのサムネイル一覧
 */
export const getFileThumbnails = (
    params?: GetFileThumbnailsParams,
 ) => {
      return getFileThumbnailsMutator<GetFileThumbnailsResponse>(
      {url: `/files/thumbnails`, method: 'GET',
        params
    },
      );
    }
  /**
 * ファイルの地理座標（LRF Target 緯度経度）と表示用の最小フィールドを返します。
 * itemsPerPage を省略した場合はサーバー側の固定上限まで返します。指定値が固定上限を超える場合は固定上限まで返します。
 * @summary ファイルの地理座標一覧
 */
export const getFileGeoPoints = (
    params?: GetFileGeoPointsParams,
 ) => {
      return getFileGeoPointsMutator<GetFileGeoPointsResponse>(
      {url: `/files/geo-points`, method: 'GET',
        params
    },
      );
    }
  /**
 * サーマル画像の温度情報ファイルの抽出を実行する
 * @summary サーマル画像の温度情報ファイル抽出実行
 */
export const getFileTemperature = (
    fileId: number,
 ) => {
      return getFileTemperatureMutator<SuccessExecutionTemperatureExtractorResponse>(
      {url: `/files/${fileId}/temperatures`, method: 'GET'
    },
      );
    }
  export type GetFilesResult = NonNullable<Awaited<ReturnType<typeof getFiles>>>
export type PutFilesResult = NonNullable<Awaited<ReturnType<typeof putFiles>>>
export type DeleteFilesResult = NonNullable<Awaited<ReturnType<typeof deleteFiles>>>
export type GetFileResult = NonNullable<Awaited<ReturnType<typeof getFile>>>
export type PutFileResult = NonNullable<Awaited<ReturnType<typeof putFile>>>
export type GetFilePageNumberResult = NonNullable<Awaited<ReturnType<typeof getFilePageNumber>>>
export type PostFilesUploadResult = NonNullable<Awaited<ReturnType<typeof postFilesUpload>>>
export type PostFilesCommentResult = NonNullable<Awaited<ReturnType<typeof postFilesComment>>>
export type PutFilesCommentResult = NonNullable<Awaited<ReturnType<typeof putFilesComment>>>
export type DeleteFilesCommentResult = NonNullable<Awaited<ReturnType<typeof deleteFilesComment>>>
export type GetFilesCountsResult = NonNullable<Awaited<ReturnType<typeof getFilesCounts>>>
export type PostFilesDownloadResult = NonNullable<Awaited<ReturnType<typeof postFilesDownload>>>
export type GetFilesDownloadResult = NonNullable<Awaited<ReturnType<typeof getFilesDownload>>>
export type FilesCsvExportResult = NonNullable<Awaited<ReturnType<typeof filesCsvExport>>>
export type GetFileGroupsResult = NonNullable<Awaited<ReturnType<typeof getFileGroups>>>
export type GetFileThumbnailsResult = NonNullable<Awaited<ReturnType<typeof getFileThumbnails>>>
export type GetFileGeoPointsResult = NonNullable<Awaited<ReturnType<typeof getFileGeoPoints>>>
export type GetFileTemperatureResult = NonNullable<Awaited<ReturnType<typeof getFileTemperature>>>
